import React from "react";
import { Divider, Row, Col, Button } from "antd";
import { VisitorDetails } from "./components";
import { useTranslation } from "react-i18next";

const ChatbotVisitor = () => {
  const { t } = useTranslation();
  return (
    <div>
      <>
        <div className="visitor-details-header">
          <Row className="visitor-details-row">
            <Col className="visitor-details-col">
              <h5 className="visitor-details-title">
                {t("chatMessages.visitor.visitorDetails")}
              </h5>
            </Col>
          </Row>
        </div>

        <div className="visitor-details-container">
          {/* Visitor Details */}
          <VisitorDetails />

          {/* Divider */}
          <Divider />

          {/* If selectedChat.ticket contains an ID, add a button saying view ticket details */}
          <>
            <Row
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: "5px",
              }}
            >
              <Col
                style={{
                  marginRight: "10px",
                }}
              >
                <h5
                  style={{
                    display: "block",
                    fontWeight: 600,
                  }}
                >
                  {t("chatMessages.visitor.ticketDetails")}
                </h5>
              </Col>
            </Row>

            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: "0.5rem",
              }}
            >
              <Button
                style={{
                  background: "#0b4eb8",
                  color: "#fff",
                  borderRadius: "8px",
                  height: "30px",
                  width: "100%",
                }}
                size="small"
                type="primary"
              >
                {t("chatMessages.visitor.viewTicket")}
              </Button>
            </div>
          </>
        </div>
      </>
    </div>
  );
};

export default ChatbotVisitor;
